import apiClient from '@/api/client'
import { Dictionary } from '@/types/field'

export default class DashboardAPI {
    static transactionHistoryList(payload: Dictionary) {
        return apiClient.post('/transaction/history-list', payload)
    }
}
